import { request } from './http';

export async function getEngines(params = {}) {
    const q = new URLSearchParams();
    if (params.siteId != null) q.set('siteId', params.siteId);
    if (params.siteIds != null) {
      const ids = Array.isArray(params.siteIds) ? params.siteIds.join(',') : params.siteIds;
      q.set('siteIds', ids);
    }
    if (params.customerId != null) q.set('customerId', params.customerId);
    if (params.enginesActiveOnly === false) q.set('enginesActiveOnly', 'false');
    const query = q.toString();
    return request(`/engines${query ? `?${query}` : ''}`);
  }

export async function getEngine(id) {
    return request(`/engines/${id}`);
  }

export async function createEngine(data) {
    return request('/engines', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateEngine(id, data) {
    return request(`/engines/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function getEngineSiteUsers(siteId) {
    return request(`/engines/site-users/${siteId}`);
  }

export async function getEngineUses() {
    return request('/engine-uses');
  }

export async function createEngineUse(data) {
    return request('/engine-uses', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function getEngineRunningHours(params = {}) {
    const q = new URLSearchParams();
    if (params.siteId != null) q.set('siteId', params.siteId);
    if (params.engineId != null) q.set('engineId', params.engineId);
    const query = q.toString();
    return request(`/engine-running-hours${query ? `?${query}` : ''}`);
  }

export async function createEngineRunningHour(data) {
    return request('/engine-running-hours', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function createEngineRunningHoursBulk(records) {
    return request('/engine-running-hours/bulk', {
      method: 'POST',
      body: JSON.stringify({ records }),
    });
  }

export async function updateEngineRunningHour(id, data) {
    return request(`/engine-running-hours/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteEngineRunningHour(id) {
    return request(`/engine-running-hours/${id}`, {
      method: 'DELETE',
    });
  }

export const enginesApi = {
  getEngines,
  getEngine,
  createEngine,
  updateEngine,
  getEngineSiteUsers,
  getEngineUses,
  createEngineUse,
  getEngineRunningHours,
  createEngineRunningHour,
  createEngineRunningHoursBulk,
  updateEngineRunningHour,
  deleteEngineRunningHour,
};

